import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const ScrollLine = () => {
  const { scrollYProgress } = useScroll();

  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    mass: 0.4,
  });

  return (
    <div className="pointer-events-none fixed right-5 top-1/2 z-[90] hidden -translate-y-1/2 lg:block">
      {/* Track */}
      <div className="relative h-[180px] w-[2px] rounded-full bg-white/[0.08]">
        {/* Progress */}
        <motion.div
          className="absolute left-0 top-0 w-full origin-top rounded-full bg-gradient-to-b from-orange-400 via-orange-500 to-purple-500 shadow-[0_0_12px_rgba(249,115,22,0.6)]"
          style={{
            height: "100%",
            scaleY: smoothProgress,
          }}
        />

        {/* Moving glow */}
        <motion.div
          className="absolute left-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-orange-400 shadow-[0_0_15px_rgba(249,115,22,0.9)]"
          style={{
            top: smoothProgress,
          }}
        />

        {/* Top dot */}
        <div className="absolute -left-[3px] top-0 h-2 w-2 rounded-full bg-orange-400 shadow-[0_0_10px_rgba(249,115,22,0.8)]" />

        {/* Bottom dot */}
        <div className="absolute -left-[3px] bottom-0 h-2 w-2 rounded-full bg-purple-500 shadow-[0_0_10px_rgba(168,85,247,0.7)]" />
      </div>
    </div>
  );
};

export default ScrollLine;
